<div style="text-align: center; margin-bottom: 20px;">
    <h1>Reset your password</h1>
</div>

<div style="width: 600px; margin: 0 auto;">
    <div style="background-color: #fff; padding: 20px; border-radius: 10px;">
        <div class="form-group">
            <app-textbox [label]="'Password'" [width]="'100%'" [type]="'Password'" id="password" name="password" [(ngModel)]="password" />
        </div>
        <div class="form-group">
            <app-textbox [label]="'Retype Password'" [width]="'100%'" [type]="'Password'" id="password" name="password" [(ngModel)]="password2" />
        </div>
        <div style="font-size:.9em;">
            Password requirements:
            <ul>
                <li>
                    at least 8 characters long
                </li>
                <li>
                    contains an upper case character
                </li>
                <li>
                    contains a numeric character
                </li>
                <li>
                    contains a non-alphanumeric character
                </li>
            </ul>
        </div>
        <div class="form-group">
            <button class="btn-core" style="width:100%;" (click)="btnChangePassword_click()">Save New Password</button>
        </div>
    </div>

</div>
